// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * EventType describes (as the name implies) the types of events that can be captured by analytics
 */
export var EventType;
(function (EventType) {
    EventType["REVIEW"] = "REVIEW";
    EventType["REPLY"] = "REPLY";
    EventType["INVITATION_SENT"] = "INVITATION_SENT";
    EventType["INVITATION_VIEWED"] = "INVITATION_VIEWED";
    EventType["INVITATION_CLICKED"] = "INVITATION_CLICKED";
    EventType["SYNC"] = "SYNC";
    EventType["SITE_REMOVED"] = "SITE_REMOVED";
    EventType["REVIEW_DELETED"] = "REVIEW_DELETED";
    EventType["REPLY_DELETED"] = "REPLY_DELETED";
})(EventType || (EventType = {}));
export var EventType_index;
(function (EventType_index) {
    EventType_index[EventType_index["REVIEW"] = 0] = "REVIEW";
    EventType_index[EventType_index["REPLY"] = 1] = "REPLY";
    EventType_index[EventType_index["INVITATION_SENT"] = 2] = "INVITATION_SENT";
    EventType_index[EventType_index["INVITATION_VIEWED"] = 3] = "INVITATION_VIEWED";
    EventType_index[EventType_index["INVITATION_CLICKED"] = 4] = "INVITATION_CLICKED";
    EventType_index[EventType_index["SYNC"] = 5] = "SYNC";
    EventType_index[EventType_index["SITE_REMOVED"] = 6] = "SITE_REMOVED";
    EventType_index[EventType_index["REVIEW_DELETED"] = 7] = "REVIEW_DELETED";
    EventType_index[EventType_index["REPLY_DELETED"] = 8] = "REPLY_DELETED";
})(EventType_index || (EventType_index = {}));
/**
 * RecommendationType describes a rating when the rating is positive/negative instead of a star rating
 */
export var RecommendationType;
(function (RecommendationType) {
    RecommendationType["NONE"] = "NONE";
    RecommendationType["POSITIVE"] = "POSITIVE";
    RecommendationType["NEGATIVE"] = "NEGATIVE";
})(RecommendationType || (RecommendationType = {}));
export var RecommendationType_index;
(function (RecommendationType_index) {
    RecommendationType_index[RecommendationType_index["NONE"] = 0] = "NONE";
    RecommendationType_index[RecommendationType_index["POSITIVE"] = 1] = "POSITIVE";
    RecommendationType_index[RecommendationType_index["NEGATIVE"] = 2] = "NEGATIVE";
})(RecommendationType_index || (RecommendationType_index = {}));
export var RangePreset;
(function (RangePreset) {
    RangePreset["RANGE_PRESET_UNSPECIFIED"] = "RANGE_PRESET_UNSPECIFIED";
    RangePreset["ALL_TIME"] = "ALL_TIME";
    RangePreset["FIVE_YEARS"] = "FIVE_YEARS";
    RangePreset["TWELVE_MONTHS"] = "TWELVE_MONTHS";
    RangePreset["SIX_MONTHS"] = "SIX_MONTHS";
    RangePreset["THREE_MONTHS"] = "THREE_MONTHS";
    RangePreset["THIRTY_DAYS"] = "THIRTY_DAYS";
    RangePreset["SEVEN_DAYS"] = "SEVEN_DAYS";
})(RangePreset || (RangePreset = {}));
export var RangePreset_index;
(function (RangePreset_index) {
    RangePreset_index[RangePreset_index["RANGE_PRESET_UNSPECIFIED"] = 0] = "RANGE_PRESET_UNSPECIFIED";
    RangePreset_index[RangePreset_index["ALL_TIME"] = 1] = "ALL_TIME";
    RangePreset_index[RangePreset_index["FIVE_YEARS"] = 2] = "FIVE_YEARS";
    RangePreset_index[RangePreset_index["TWELVE_MONTHS"] = 3] = "TWELVE_MONTHS";
    RangePreset_index[RangePreset_index["SIX_MONTHS"] = 4] = "SIX_MONTHS";
    RangePreset_index[RangePreset_index["THREE_MONTHS"] = 5] = "THREE_MONTHS";
    RangePreset_index[RangePreset_index["THIRTY_DAYS"] = 6] = "THIRTY_DAYS";
    RangePreset_index[RangePreset_index["SEVEN_DAYS"] = 7] = "SEVEN_DAYS";
})(RangePreset_index || (RangePreset_index = {}));
export var BucketSize;
(function (BucketSize) {
    BucketSize["BUCKET_SIZE_UNSPECIFIED"] = "BUCKET_SIZE_UNSPECIFIED";
    BucketSize["DAY"] = "DAY";
    BucketSize["WEEK"] = "WEEK";
    BucketSize["MONTH"] = "MONTH";
})(BucketSize || (BucketSize = {}));
export var BucketSize_index;
(function (BucketSize_index) {
    BucketSize_index[BucketSize_index["BUCKET_SIZE_UNSPECIFIED"] = 0] = "BUCKET_SIZE_UNSPECIFIED";
    BucketSize_index[BucketSize_index["DAY"] = 1] = "DAY";
    BucketSize_index[BucketSize_index["WEEK"] = 2] = "WEEK";
    BucketSize_index[BucketSize_index["MONTH"] = 3] = "MONTH";
})(BucketSize_index || (BucketSize_index = {}));
